import { render } from "./NominateList.vue?vue&type=template&id=015f9d45&scoped=true"
import script from "./NominateList.vue?vue&type=script&lang=js"
export * from "./NominateList.vue?vue&type=script&lang=js"

import "@/assets/css/style_parts.css?vue&type=style&index=0&id=015f9d45&lang=css&scoped=true"
import "@/assets/css/style_ranking.css?vue&type=style&index=1&id=015f9d45&lang=css&scoped=true"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015f9d45"]])

export default __exports__